import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useAuthStore } from '@/store/authStore';
import type { UserRole } from '@/types';

interface ProtectedRouteProps {
  children: ReactNode;
  requireRoles?: UserRole[];
  /** User cần có ít nhất 1 trong các permissions này (HOẶC vai trò SYS_ADMIN) */
  requirePermissions?: string[];
}

export function ProtectedRoute({ children, requireRoles, requirePermissions }: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, hasAnyRole, hasAnyPermission } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check vai trò trước
  if (requireRoles && requireRoles.length > 0 && !hasAnyRole(requireRoles)) {
    return forbiddenView();
  }

  // Check permissions
  if (requirePermissions && requirePermissions.length > 0 && !hasAnyPermission(requirePermissions)) {
    return forbiddenView();
  }

  return <>{children}</>;
}

function forbiddenView() {
  return (
    <Result
      status="403"
      title="403 - Không có quyền truy cập"
      subTitle="Bạn không có quyền truy cập trang này."
      extra={
        <Button type="primary" onClick={() => window.history.back()}>
          Quay lại
        </Button>
      }
    />
  );
}
